module.exports = __webpack_public_path__ + "img/profile_two_003.23a5a055.png";